import ScrollTrigger from 'gsap/ScrollTrigger';
import { removeFadeInOnScrollClasses } from '../animations/fadeInOnScroll';
import wpAjax from '../helpers/axios';
import { reInitTooltips } from './tooltips';

async function runFilter(filter, callbackFn) {
	// Fade out container
	const container = document.querySelector('.js-posts-container');
	container.classList.add('is-faded');

	// Get filter options to send to backend
	const filterOptions = {};
	const taxonomies = document.querySelectorAll('.js-taxonomy-options');
	taxonomies.forEach((tax) => {
		const taxName = tax.getAttribute('data-taxonomy-name');
		let activeOptions = tax.querySelectorAll('.js-filter-option.is-active');
		if (activeOptions.length > 0) {
			filterOptions[taxName] = Array.from(activeOptions).map((option) => {
				return option.getAttribute('data-term-id');
			});
		}
	});

	// Make request to backend
	const { data } = await wpAjax.post('', {
		action: 'ajax_filter_posts',
		post_type: filter.getAttribute('data-post-type'),
		filters: filterOptions,
	});

	// Replace html
	container.innerHTML = data;
	container.classList.remove('is-faded');

	// Refresh scrolltrigger
	ScrollTrigger.refresh();

	// Reinit tooltips
	reInitTooltips();

	// Remove fade-in on scroll classes
	removeFadeInOnScrollClasses(container);

	// Run the callback function, if passed.
	if (callbackFn) callbackFn();
}

function resetFilter(filter) {
	// Reset filter
	filter.querySelectorAll('.c-filter__option').forEach((el) => {
		el.classList.remove('is-active');
	});

	runFilter(filter, () => filter.classList.remove('is-open'));
}

function initFilters() {
	const filter = document.querySelector('.c-filter');
	if (filter) {
		const filterOptionsToggle = filter.querySelector('.js-toggle-filter-options');
		const filterOptions = filter.querySelectorAll('.js-filter-option');
		const seeAllOptions = filter.querySelectorAll('.js-filter-option-reset');

		// Toggle filter options
		filterOptionsToggle.addEventListener('click', () => {
			filter.classList.toggle('is-open');
		});

		// Handle filter option click
		filterOptions.forEach((el) => {
			el.addEventListener('click', () => {
				if (el.classList.contains('c-filter__in-out-option')) {
					// Whats on filter
					// Reveal filter on first click of in/out options
					filter.querySelector('.c-filter__top-bar').classList.remove('hidden');

					// Handle active states for whats on in/out options
					filter
						.querySelectorAll('.c-filter__in-out-option')
						.forEach((el) => el.classList.remove('is-active'));
					el.classList.add('is-active');
				} else {
					// Normal filters
					// remove active state from see all button
					el.parentElement
						?.querySelector('.js-filter-option-reset')
						?.classList.remove('is-active');

					// Add active state to option
					el.classList.toggle('is-active');
				}

				runFilter(filter);
			});
		});

		// Filter reset
		filter
			.querySelector('.c-filter__reset')
			.addEventListener('click', () => resetFilter(filter));

		// Handle 'see all' option click
		seeAllOptions.forEach((el) => {
			el.addEventListener('click', () => {
				// Remove active states from other options
				el.parentElement.querySelectorAll('.js-filter-option').forEach((el) => {
					el.classList.remove('is-active');
				});

				// Add active state
				el.classList.add('is-active');

				runFilter(filter);
			});
		});
	}
}

initFilters();
